import { render, staticRenderFns } from "./schoolManage.vue?vue&type=template&id=f1e2428e&scoped=true&"
import script from "./schoolManage.vue?vue&type=script&lang=js&"
export * from "./schoolManage.vue?vue&type=script&lang=js&"
import style0 from "./schoolManage.vue?vue&type=style&index=0&id=f1e2428e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e2428e",
  null
  
)

export default component.exports